import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TerceroZonaService } from '../../../../_services/tercero-zona.service';
import { NavService } from '../../../../_services/_nav.service';
import { Ejecutivo } from '../../../../_models/ejecutivo';
import { Router } from '@angular/router';
import { BusquedaFiltros } from '../../../../_models/busqueda-filtros';

@Component( {
  selector: 'app-widget-prospecto-perfil-ejecutivo',
  templateUrl: 'widget-prospecto-perfil-ejecutivo.component.html'
} )

export class WidgetProspectoPerfilEjecutivoComponent implements OnInit {


  @Input()
  set idOficina( idOficina: string ) {
    this._idOficina = idOficina;
    if ( this._idOficina !== undefined ) {
      this.filtrar();
    }
  }

  get idOficina(): string {
    return this._idOficina;
  }

  @Input()
  set idAgrupacion( idAgrupacion: string ) {
    this._idAgrupacion = idAgrupacion;
    if ( this._idAgrupacion !== undefined ) {
      this.filtrar();
    }
  }

  get idAgrupacion(): string {
    return this._idAgrupacion;
  }

  @Input()
  set refrescar( refrescar: boolean ) {
    this._refrescar = refrescar;
    if ( this._refrescar ) {
      this.filtrar();
    }
  }

  get refrescar(): boolean {
    return this._refrescar;
  }

  _refrescar: boolean;

  _idAgrupacion: string;

  _idOficina: string;

  carDatos = false;

  @Output() cargando: EventEmitter<boolean> = new EventEmitter();

  lisEjecutivos: any[] = [];

  constructor( private terZonaServicio: TerceroZonaService, private navServicio: NavService, private router: Router ) {
  }

  ngOnInit(): void {
  }

  filtrar() {
    this.carDatos = true;
    this.cargando.emit(true);
    const filtro = {} as BusquedaFiltros;
    filtro.idEstructuraFisica = this._idOficina;
    filtro.idAgrupacion = this._idAgrupacion;
    this.terZonaServicio.filtroEstructuraZonaEjecutivo( filtro ).subscribe( listado => {
      const lista = [];
      listado.map( ( s: Ejecutivo ) => {
        const a = {
          tercero: s.tercero ? s.tercero.tercero : this.navServicio.buscarMensaje( 'INICIO_DASHBOARD.LBL_ZONALIBRE' ),
          zona: (s.zona.estructura ? s.zona.estructura + ' - ' : '') + s.zona.nombre + (s.tercero && !s.tercero.indicadorPrincipal ? ' - ' + this.navServicio.buscarMensaje( 'INICIO_DASHBOARD.LBL_SECUNDARIA' ) : ''),
          idZona: s.zona.idZona
        };
        lista.push( a );
      } );
      this.lisEjecutivos = lista;
      this.cargando.emit(false);
      this.carDatos = false;
    } );
  }

  gestionar( registro: any ) {
    this.router.navigate( [ 'gen/ejecutivo/' + registro.idZona ] );
  }


}
